import script from "./SliderProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderProducts.vue?vue&type=script&setup=true&lang=js"

import "./SliderProducts.vue?vue&type=style&index=0&id=139c06b1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-139c06b1"]])

export default __exports__